import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import PropTypes from "prop-types";
import { Accordion as CoreAccordion } from "@vds-core/accordions";
var propTypes = {
  /**
   * Allows the top line of the Accordion to render with 'heavy' or 'light' thickness
   */
  topLineType: PropTypes.oneOf(["light", "heavy"]),

  /**
   * @ignore
   * 3.0 only
   */
  topLine: PropTypes.bool,

  /**
   * @ignore
   * 3.0 only
   */
  bottomLine: PropTypes.bool,

  /**
   * Component will render in Inverted state.
   */
  inverted: PropTypes.bool,

  /**
   * @deprecated
   * If true, the Accordion will open only one AccordionItem at a time
   */
  single: PropTypes.bool
};
var defaultProps = {
  topLineType: "heavy",
  inverted: false,
  single: false
};

var Accordion = /*#__PURE__*/function (_React$Component) {
  _inherits(Accordion, _React$Component);

  var _super = _createSuper(Accordion);

  function Accordion() {
    _classCallCheck(this, Accordion);

    return _super.apply(this, arguments);
  }

  _createClass(Accordion, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(CoreAccordion, _extends({}, this.props, {
        topLine: false // 3.0 only
        ,
        surface: this.props.inverted ? "dark" : "light",
        bottomLine: true,
        topLineType: this.props.topLineType,
        bottomLinePrimary: true,
        type: this.props.single ? "single" : this.props.type
      }));
    }
  }]);

  return Accordion;
}(React.Component);

Accordion.propTypes = propTypes;
Accordion.defaultProps = defaultProps;
export default Accordion;